import { render, staticRenderFns } from "./MaterialSnRuleEdit.vue?vue&type=template&id=85a165e6&"
import script from "./MaterialSnRuleEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialSnRuleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports